const BC_INSTANCE = "Production";
const BC_COMNPANY_ID = "e4d8b028-7cd0-f011-8bce-7ced8d3f50a2";
const BC_COMPANY_NAME = "CRONUS IN";
export const BC_API_BASE_URL_WD =
  "https://api.businesscentral.dynamics.com/v2.0/3b8c3bc4-6e86-4c00-a782-ae0f5c8d2873/" +
  BC_INSTANCE +
  "/ODataV4/Company('" +
  encodeURIComponent(BC_COMPANY_NAME) +
  "')";

export const BC_API_BASE_URL =
  "https://api.businesscentral.dynamics.com/v2.0/3b8c3bc4-6e86-4c00-a782-ae0f5c8d2873/" +
  BC_INSTANCE +
  "/api/v2.0/companies(" +
  BC_COMNPANY_ID +
  ")";

//export const CARE_MW_API_BASE_URL = "http://localhost:50001"; // when used in local docker
export const CARE_MW_API_BASE_URL = "https://api.arminas.ekaivadigital.com"; // when deployed in hostinger
